import Nullstack from 'nullstack';
export default function IconBrandUnity({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-unity",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 3l6 4v7"
  }), "   ", Nullstack.element("path", {
    d: "M18 17l-6 4l-6 -4"
  }), "   ", Nullstack.element("path", {
    d: "M4 14v-7l6 -4"
  }), "   ", Nullstack.element("path", {
    d: "M4 7l8 5v9"
  }), "   ", Nullstack.element("path", {
    d: "M20 7l-8 5"
  }), " ");
}